import { Chakra, Icons } from "@airhelp/react-ui-components";
import { icons } from "styles/icons";

const { Flex, Heading, Text, Box } = Chakra;

export interface CardMobileProps {
  icon: string;
  heading: string;
  text: string;
  subHeading?: string;
}

const CardMobile = ({ icon, heading, text, subHeading }: CardMobileProps) => {
  const Icon = Icons[icon] || icons[icon];

  return (
    <Box mr={4} _last={{ pr: 4 }}>
      <Flex w={72} py={10} pl={8} pr={7} rounded="lg" flexDir="column" h="full" bg="white" borderColor="greyscale.400">
        <Icon h="auto" w={10} mb={6} color="primary.500" />
        {subHeading && (
          <Text
            color="greyscale.500"
            textTransform="uppercase"
            letterSpacing="1.5px"
            fontWeight="bold"
            mb={4}
            textAlign="left"
            fontSize="xs"
          >
            {subHeading}
          </Text>
        )}
        <Heading variant="h3" as="h3" mb={4} textAlign="left">
          {heading}
        </Heading>
        <Text textAlign="left" fontSize="md">
          {text}
        </Text>
      </Flex>
    </Box>
  );
};

export default CardMobile;
